import type { SessionSource } from "@constants/tracking";
import { useSession } from "@features/session/hooks/useSession";
import type { PracticeTestExam } from "@memorang/types";
import { router } from "expo-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const useDiagnostic = () => {
	const { t } = useTranslation();

	const messages = [
		t("sessionConfig.configuringSession"),
		t("sessionConfig.fetchingContent"),
		t("sessionConfig.preparingMaterials"),
		t("sessionConfig.almostThere"),
		t("sessionConfig.startingSession"),
	];
	const [showPermissionDialog, setShowPermissionDialog] = useState(false);
	const {
		handleCreateCommonSession,
		isCreatingSession,
		showErrorDialog,
		toggleShowErrorDialog,
	} = useSession();
	const handleCreateSession = ({
		isSessionConfig,
		handleClose,
		exam,
		source,
	}: {
		exam: PracticeTestExam;
		isSessionConfig?: boolean;
		handleClose?: () => void;
		source: SessionSource;
	}) => {
		const dist = {
			low: 0,
			high: 0,
			medium: 0,
			none: 0,
		};

		return handleCreateCommonSession({
			dist,
			tags: [],
			handleClose,
			push: !isSessionConfig,
			source,
			additionalSessionParams: {
				title: exam?.title!,
				icon: exam?.icon!,
				sessionSubType: "DIAGNOSTIC",
				examId: exam?.id,
				collectionId: exam?.collectionId,
				examStatus: exam?.status,
				sessionId: exam?.numericId,
			},
		});
	};

	const handleViewReport = (sessionNumericId: number) => {
		router.replace({
			pathname: "/(protected)/session/[id]/report",
			params: {
				id: sessionNumericId,
			},
		});
	};

	return {
		handleCreateSession,
		handleViewReport,
		showPermissionDialog,
		isCreatingSession,
		showErrorDialog,
		toggleShowErrorDialog,
		setShowPermissionDialog,
		messages,
	};
};

export default useDiagnostic;
